import React from "react";
import "./FleetCoreImplementationResponsibleIntelligence.css";

import fleetcoreImplementationPathwayDesktop from "../../images/fleetcore-implementation-responsible-intelligence-pathway-desktop.svg";
import fleetcoreImplementationPathwayMobile from "../../images/fleetcore-implementation-responsible-intelligence-pathway-mobile.svg";
import fleetcoreResponsibleIntelligenceFramework from "../../images/fleetcore-implementation-responsible-intelligence-framework.svg";
import fleetcoreFinalConversionBackground from "../../images/fleetcore-implementation-final-conversion-luminous-background.svg";

export default function FleetCoreImplementationResponsibleIntelligence({
  onBookDemo,
  onBrochureClick,
}) {
  return (
    <section className="fleetcore-implementation-responsible-intelligence" id="fleetcore-implementation" aria-labelledby="fleetcore-implementation-responsible-intelligence-title">
      <div className="fleetcore-implementation-responsible-intelligence__inner">
        <div className="fleetcore-implementation-responsible-intelligence__copy">
          <p className="fleetcore-implementation-responsible-intelligence__eyebrow">IMPLEMENTATION, NOT DISRUPTION</p>
          <h2 id="fleetcore-implementation-responsible-intelligence-title">Implement around the way your fleet already works.</h2>
          <p className="fleetcore-implementation-responsible-intelligence__body">Configure roles, evidence requirements, review thresholds and rollout sequence around your operation. Start with a focused pilot; refine from real shifts; scale when the process is ready.</p>
        </div>
        <img className="fleetcore-implementation-responsible-intelligence__framework" src={fleetcoreResponsibleIntelligenceFramework} alt="Responsible intelligence framework covering evidence, configured thresholds, human review and audit trail" />
        <picture className="fleetcore-implementation-responsible-intelligence__pathway">
          <source media="(max-width: 699px)" srcSet={fleetcoreImplementationPathwayMobile} />
          <img src={fleetcoreImplementationPathwayDesktop} alt="Configure, pilot, validate and scale FleetCore implementation pathway" />
        </picture>
        <div className="fleetcore-implementation-responsible-intelligence__conversion" style={{ backgroundImage: `url(${fleetcoreFinalConversionBackground})` }}>
          <p>MAKE EVERY FLEET EVENT ACCOUNTABLE</p>
          <h3>Ready to bring the evidence together?</h3>
          <span>Book a FleetCore demonstration or discuss a focused deployment for your fleet operation.</span>
          <div className="fleetcore-implementation-responsible-intelligence__actions">
            <button type="button" onClick={onBookDemo}>Book a FleetCore demo</button>
            <button
              type="button"
              className="fleetcore-implementation-responsible-intelligence__brochure-button"
              onClick={onBrochureClick}
            >
              Download brochure
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
